import { render, staticRenderFns } from "./fireFightingTraningEduDetail.vue?vue&type=template&id=68d1708f"
import script from "./fireFightingTraningEduDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingTraningEduDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d1708f')) {
      api.createRecord('68d1708f', component.options)
    } else {
      api.reload('68d1708f', component.options)
    }
    module.hot.accept("./fireFightingTraningEduDetail.vue?vue&type=template&id=68d1708f", function () {
      api.rerender('68d1708f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/fte/fireFightingTraningEduDetail.vue"
export default component.exports